import { Component, OnInit, Input, Output, SimpleChanges, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import { RequisitionService } from '../services/requisition.service';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { MessageBoxDialog } from '../message-box/message-box.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-list-qa',
  templateUrl: './list-qa.component.html',
  styleUrls: ['./list-qa.component.css']
})
export class ListQaComponent implements OnInit {

  listQa: any;
  loading: boolean;
  size: number;
  page: number;
  total: number;
  public questionFormGroup: FormGroup;
  public answer: String[];

  constructor(
    private dialog: MatDialog,
    private requisitionService: RequisitionService,
    private fb: FormBuilder,
    private _router: Router
  ) {
    this.loading = false;
    this.size = 10;

    this.questionFormGroup = this.fb.group({
      answer: ['', Validators.required],
    });
  
    this.answer = [];
  }

  ngOnInit() {
    this.refreshListing(1);
  }

  ngOnChanges(changes: SimpleChanges) {
    this.refreshListing(1);
  }

  refreshListing(page) {
    this.loading = true;
    this.requisitionService.getQaUnanswer()
    .subscribe(
      res => {
        this.loading = false;
        this.page = page;
        this.total = res.pagination.total;
        this.listQa = res.qa;
      },
      () => {
        console.log('Error retrieving Requisitions');
        this.loading = false;
      }
    );
  }

  gotoRequisition(qa) {
    this._router.navigate(['/viewrequisition', qa.requisition.id]);
  }

  onPutQuestion(qa, answer, index) {
    console.log(answer);
    this.requisitionService.putQuestionAnswer(qa.id, answer)
    .subscribe(
      data => {
        this.answer.splice(index, 1);
        this.refreshListing(this.page);
      },
      error => {
        const errorMessage = <any>error;
        this.dialog.open(MessageBoxDialog, {data: {message: 'Hubo un error al realizar la respuesta: ' + errorMessage, information: true, showIcon: true}});
      }
    );
  }

  showInformation() {
    this.dialog.open(MessageBoxDialog, {data:
      {message: 'Listado de preguntas sin responder', information: true, showIcon: true}});
  }
}



// WEBPACK FOOTER //
// /Users/everis/code/Dj/front.staff/src/app/list-qa/list-qa.component.ts